import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';

import Alert from '../alert';

class AccountAlerts extends Component {
  renderPasswordSentAlert() {
    const { email } = this.props;
    if (this.props.isPasswordRecoverSent) {
      return (
        <Alert type="success">
          <FormattedMessage
            id="account.alerts.passwordSent"
            defaultMessage="A link to reset your password was sent to {email}"
            values={{ email }}
          />
        </Alert>
      );
    }
  }

  renderAccountUpdatedAlert() {
    if (this.props.isAccountUpdatedAlertVisible) {
      return (
        <Alert type="success">
          <FormattedMessage
            id="account.alerts.saved"
            defaultMessage="Changes saved"
          />
        </Alert>
      );
    }
  }

  renderErrorAlert() {
    if (this.props.errorAlert) {
      return (
        <Alert type="danger">
          {this.props.errorAlert.content}
        </Alert>
      );
    }
  }

  render() {
    return (
      <div className="account-alerts">
        {this.renderAccountUpdatedAlert()}
        {this.renderPasswordSentAlert()}
        {this.renderErrorAlert()}
      </div>
    );
  }
}

export default AccountAlerts;



// WEBPACK FOOTER //
// ./src/desktop/components/account/alerts.js